// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__6T11K","col":"styles_col___IuZG"};